import _ from 'lodash'
import Mustache from 'mustache'
import { formatNumber } from 'core/service/lib/number-format'
import MESSAGES from 'core/data-model/constants/bi-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import VALUES from 'core/data-model/constants/values'
import { _getMessageUnderiShieldPolicyValueTable } from 'core/service/benefit-illustration/policy-value'
import { formatFromZeroToDash } from 'core/service/pdf-generation/utils/table-utils'
import { isAnnuallyPensionType, getPensionTypeString } from 'core/service/benefit-illustration/products/retirement'
import { getToggles } from 'quick-quote/feature-toggles'

// this is a hack for line wrapping in pdf which is not
// support Thai language yet. Once it is implemented
// this should be removed
export const _breakLine = (text) => {
  const premiumPattern = /^(เบี้ยประกันภัย)(สัญญา.+)$/
  const deathBenefitPattern = /^(ความคุ้มครอง)(การเสียชีวิต)$/
  const surrenderCashPattern = /^(มูลค่าเวนคืน)(เงินสด)$/
  const savingWithCompany = /^(กรณีรับเป็น)(เงินสด)$/

  const patterns = [premiumPattern, deathBenefitPattern, surrenderCashPattern, savingWithCompany]

  // add space to trick pdfmake to do line wrapping for us
  const breakByFirstMatched = ([p, ...rest]) => (text.match(p) ? text.replace(p, '$1 $2') : breakByFirstMatched(rest))

  return breakByFirstMatched(patterns)
}

const rowHeightConfig = { lineHeight: 0.75, margin: [0, -3, 0, 0] }

const getBuildIRetirePolicyValueRow = (yearEndPolicy, pensionType) => {
  return isAnnuallyPensionType(pensionType)
    ? buildIRetireAnnuallyPolicyValueRow(yearEndPolicy)
    : buildIRetireMonthlyPolicyValueRow(yearEndPolicy)
}

const getBuildLifeRetirePolicyValueRow = (yearEndPolicy, pensionType) => {
  if (isAnnuallyPensionType(pensionType)) {
    return getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? buildLifeRetireAnnuallyPolicyValueRowWithNoRiderAndTotalPremium(yearEndPolicy)
      : buildLifeRetireAnnuallyPolicyValueRow(yearEndPolicy)
  } else {
    return getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? buildLifeRetireMonthlyPolicyValueRowWithNoRiderAndTotalPremium(yearEndPolicy)
      : buildLifeRetireMonthlyPolicyValueRow(yearEndPolicy)
  }
}

const buildIRetireMonthlyPolicyValueRow = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.monthEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualRiderPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualRiderPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualTotalPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualTotalPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const buildLifeRetireMonthlyPolicyValueRow = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.age.value > 60 ? yearEndPolicy.monthEndPolicy : '',
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualRiderPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualRiderPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualTotalPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualTotalPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.cumulativePersionAmount, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const buildLifeRetireMonthlyPolicyValueRowWithNoRiderAndTotalPremium = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.age.value > 60 ? yearEndPolicy.monthEndPolicy : '',
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.cumulativePersionAmount, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const buildIRetireAnnuallyPolicyValueRow = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualRiderPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualRiderPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualTotalPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualTotalPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const buildLifeRetireAnnuallyPolicyValueRow = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualRiderPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualRiderPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualTotalPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualTotalPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.cumulativePersionAmount, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const buildLifeRetireAnnuallyPolicyValueRowWithNoRiderAndTotalPremium = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.cumulativePersionAmount, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const getBuildIRetireTotalPolicyValueRow = (policyValue, pensionType) => {
  return isAnnuallyPensionType(pensionType)
    ? buildIRetireAnnuallyTotalPolicyValueRow(policyValue)
    : buildIRetireMonthlyTotalPolicyValueRow(policyValue)
}

const getBuildLifeRetireTotalPolicyValueRow = (policyValue, pensionType) => {
  if (isAnnuallyPensionType(pensionType)) {
    return getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? buildLifeRetireAnnuallyTotalPolicyValueRowWithNoRiderAndTotalPremium(policyValue)
      : buildLifeRetireAnnuallyTotalPolicyValueRow(policyValue)
  } else {
    return getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? buildLifeRetireMonthlyTotalPolicyValueRowWithNoRiderAndTotalPremium(policyValue)
      : buildLifeRetireMonthlyTotalPolicyValueRow(policyValue)
  }
}

const getWidthIRetireHeader = (pensionType) => {
  const isAnnuallyPension = isAnnuallyPensionType(pensionType)
  const widthTableAnnually = [25, 25, 'auto', 40, 45, 40, 60, 60, 60, 60]
  const widthTableMonthly = [25, 25, 15, 'auto', 40, 45, 40, 55, 55, 55, 55]
  return isAnnuallyPension ? widthTableAnnually : widthTableMonthly
}

const getWidthLifeRetireHeader = (pensionType) => {
  const widthAnnually = [25, 25, 40, 45, 40, 'auto', 50, 45, 52, 45, 45]
  const widthAnnuallyNoRiderAndTotalColumn = [25, 25, 50, 60, 55, 55, 52, 52, 52]
  const widthTableAnnually = getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
    ? widthAnnuallyNoRiderAndTotalColumn
    : widthAnnually

  const widthMonthly = [25, 25, 15, 37, 42, 37, 'auto', 50, 40, 48, 40, 40]
  const widthMonthlyNoRiderAndTotalColumn = [25, 25, 15, 50, 60, 55, 55, 52, 52, 52]
  const widthTableMonthly = getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
    ? widthMonthlyNoRiderAndTotalColumn
    : widthMonthly

  const isAnnuallyPension = isAnnuallyPensionType(pensionType)
  return isAnnuallyPension ? widthTableAnnually : widthTableMonthly
}

const getBuildIRetireHeader = (pensionType) => {
  return isAnnuallyPensionType(pensionType) ? buildIRetireAnnuallyHeaderTable() : buildIRetireMonthlyHeaderTable()
}

const getBuildLifeRetireHeader = (pensionType) => {
  if (isAnnuallyPensionType(pensionType)) {
    return getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? buildLifeRetireAnnuallyHeaderTableWithNoRiderAndTotalPremium()
      : buildLifeRetireAnnuallyHeaderTable()
  } else {
    return getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? buildLifeRetireMonthlyHeaderTableWithNoRiderAndTotalPremium()
      : buildLifeRetireMonthlyHeaderTable()
  }
}

const buildIRetireMonthlyTotalPolicyValueRow = (policyValue) => [
  '',
  '',
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.subtotalAnnualRiderPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualRiderPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.grandTotalPremium === 0 ? '-' : formatNumber(policyValue.grandTotalPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
]

const buildLifeRetireMonthlyTotalPolicyValueRow = (policyValue) => [
  '',
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.subtotalAnnualRiderPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualRiderPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.grandTotalPremium === 0 ? '-' : formatNumber(policyValue.grandTotalPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
]

const buildLifeRetireMonthlyTotalPolicyValueRowWithNoRiderAndTotalPremium = (policyValue) => [
  '',
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
]

const buildIRetireAnnuallyTotalPolicyValueRow = (policyValue) => [
  '',
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.subtotalAnnualRiderPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualRiderPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.grandTotalPremium === 0 ? '-' : formatNumber(policyValue.grandTotalPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
]

const buildLifeRetireAnnuallyTotalPolicyValueRow = (policyValue) => [
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.subtotalAnnualRiderPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualRiderPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  {
    text: policyValue.grandTotalPremium === 0 ? '-' : formatNumber(policyValue.grandTotalPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
]

const buildLifeRetireAnnuallyTotalPolicyValueRowWithNoRiderAndTotalPremium = (policyValue) => [
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
]

let disclaimer = {
  stack: [
    `${MESSAGES.NOTE}:`,
    MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_1,
    MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_2,
    MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_3,
  ],
  style: 'disclaimer',
  pageBreak: '',
}

export const iRetireShowMessageUnderPdfTable = ({ policyValue, basicPlan }) => {
  const message = _getMessageUnderiShieldPolicyValueTable({
    policyValue,
    basicPlan,
  })
  if (message) {
    return {
      stack: [{ text: message, color: 'red', fontSize: 11, alignment: 'center' }],
    }
  } else return { text: '' }
}

const buildIRetirePolicyValueTable = (policyValue, pensionType) => {
  const policyValueTables = []
  let rowsPerPage = [49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49]
  const rowsPerPagePensionMonthly = [48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48]
  if (pensionType === 'monthly') {
    rowsPerPage = rowsPerPagePensionMonthly
  }

  const pageAmount = Math.ceil(policyValue.yearEndPolicyValues.length / rowsPerPage[0])

  if (policyValue.yearEndPolicyValues.length === rowsPerPage[0]) {
    rowsPerPage[0] = rowsPerPage[0] - 1
  }
  _.times(pageAmount, (currentPage) => {
    policyValueTables.push({
      table: {
        headerRows: 1,
        widths: getWidthIRetireHeader(pensionType),
        body: [
          ...getBuildIRetireHeader(pensionType),
          ...policyValue.yearEndPolicyValues
            .slice(
              currentPage * rowsPerPage[currentPage > 0 ? currentPage - 1 : 0],
              rowsPerPage[currentPage] * (currentPage + 1)
            )
            .map((p) => getBuildIRetirePolicyValueRow(p, pensionType)),
        ],
      },
      layout: 'lightBorder',
      style: 'table25PL',
    })
  })

  _.last(policyValueTables).table.body.push(getBuildIRetireTotalPolicyValueRow(policyValue, pensionType))
  setLayoutDisclaimer(policyValueTables, rowsPerPage, disclaimer)
  return policyValueTables
}

const buildLifeRetirePolicyValueTable = (policyValue, pensionType) => {
  const policyValueTables = []
  let rowsPerPage = [49, 49, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50]
  const rowsPerPagePensionMonthly = [48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48]
  if (pensionType === 'monthly') {
    rowsPerPage = rowsPerPagePensionMonthly
  }

  const pageAmount = Math.ceil(policyValue.yearEndPolicyValues.length / rowsPerPage[0])

  if (policyValue.yearEndPolicyValues.length === rowsPerPage[0]) {
    rowsPerPage[0] = rowsPerPage[0] - 1
  }
  _.times(pageAmount, (currentPage) => {
    policyValueTables.push({
      table: {
        headerRows: 1,
        widths: getWidthLifeRetireHeader(pensionType),
        body: [
          ...getBuildLifeRetireHeader(pensionType),
          ...policyValue.yearEndPolicyValues
            .slice(
              currentPage * rowsPerPage[currentPage > 0 ? currentPage - 1 : 0],
              rowsPerPage[currentPage] * (currentPage + 1)
            )
            .map((p) => getBuildLifeRetirePolicyValueRow(p, pensionType)),
        ],
      },
      layout: 'lightBorder',
      style: 'table25PL',
    })
  })

  _.last(policyValueTables).table.body.push(getBuildLifeRetireTotalPolicyValueRow(policyValue, pensionType))
  disclaimer = {
    stack: getToggles().ENABLE_HIDING_RIDER_PREMIUM_AND_TOTAL_PREMIUM
      ? [
          `${MESSAGES.NOTE}:`,
          MESSAGES.RETIREMENT_POLICY_VALUE_NUMBER_NOTE_1,
          MESSAGES.RETIREMENT_POLICY_VALUE_NUMBER_NOTE_2,
        ]
      : [
          `${MESSAGES.NOTE}:`,
          MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_1,
          MESSAGES.LIFE_RETIREMENT_POLICY_VALUE_NOTE_2,
          MESSAGES.LIFE_RETIREMENT_POLICY_VALUE_NOTE_3,
        ],
    style: 'disclaimer',
    pageBreak: '',
  }
  setLayoutDisclaimer(policyValueTables, rowsPerPage, disclaimer)
  return policyValueTables
}

export const setLayoutDisclaimer = (
  policyValueTables,
  rowsPerPage,
  // $$FlowFixMe
  disclaimer
) => {
  const headerRow = 3
  const rowDisclaimer = 6
  const maxRowsDataforTable = 42
  const amountPage = policyValueTables.length ? policyValueTables.length : 1
  const maxofPage = rowsPerPage[amountPage - 1] + headerRow
  const rowsofPage = policyValueTables[amountPage - 1].table.body.length
  const isPageBreakforFirstPage =
    amountPage === 1 && policyValueTables[amountPage - 1].table.body.length > maxRowsDataforTable
  if (rowsofPage >= maxofPage - rowDisclaimer || isPageBreakforFirstPage) {
    disclaimer.pageBreak = 'before'
  } else {
    disclaimer.pageBreak = ''
  }
}

const buildIRetireMonthlyHeaderTable = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.END_OF_THE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_MONTHLY,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: _breakLine(MESSAGES.CUMULATIVE_PREMIUM),
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 24],
      },
      {
        text: MESSAGES.PREMIUM_PER_YEAR,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
      {
        text: MESSAGES.BENEFIT_BEFORE_GET_PENSION,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: MESSAGES.BENEFIT_DURING_GET_PENSION,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
    ],
    [
      '',
      '',
      '',
      '',
      {
        text: MESSAGES.BASIC_PLAN,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: MESSAGES.RIDER_1_STAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: MESSAGES.TOTAL,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: MESSAGES.RETIREMENT_CASH_SURRENDER_VALUE,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_MONTHLY_PDF,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_MONTHLY_TOTAL_PENSION_PDF,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', '', '', ''],
  ]
}

const buildLifeRetireMonthlyHeaderTable = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_MONTHLY,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.PREMIUM_PER_YEAR,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
      {
        text: _breakLine(MESSAGES.CUMULATIVE_PREMIUM),
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 24],
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_BEFORE_PENSION_WITH_NOTE,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_ALLOW_PENSION_NOTE_2,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
    ],
    [
      '',
      '',
      '',
      {
        text: MESSAGES.BASIC_PLAN,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: MESSAGES.RIDER_1_STAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: MESSAGES.TOTAL,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      '',
      {
        text: MESSAGES.RETIREMENT_SURRENDER_VALUE_END_OF_YEAR_NOTE_PDF,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_MONTHLY_PDF,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', '', '', ''],
  ]
}

const buildLifeRetireMonthlyHeaderTableWithNoRiderAndTotalPremium = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_MONTHLY,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.BASIC_PREMIUM_PER_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 24],
      },
      {
        text: _breakLine(MESSAGES.CUMULATIVE_PREMIUM),
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 24],
      },
      {
        text: MESSAGES.BENEFIT_BEFORE_GET_PENSION,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_ALLOW_PENSION_WITHOUT_NOTE,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
    ],
    [
      '',
      '',
      '',
      '',
      '',
      {
        text: MESSAGES.RETIREMENT_SURRENDER_VALUE_END_OF_YEAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_MONTHLY_PDF,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', '', ''],
  ]
}

const buildIRetireAnnuallyHeaderTable = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.END_OF_THE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: _breakLine(MESSAGES.CUMULATIVE_PREMIUM),
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 20],
      },
      {
        text: MESSAGES.PREMIUM_PER_YEAR,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
      {
        text: MESSAGES.BENEFIT_BEFORE_GET_PENSION,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: MESSAGES.BENEFIT_DURING_GET_PENSION,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
    ],
    [
      '',
      '',
      '',
      {
        text: MESSAGES.BASIC_PLAN,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 12],
      },
      {
        text: MESSAGES.RIDER_1_STAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 12],
      },
      {
        text: MESSAGES.TOTAL,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 12],
      },
      {
        text: MESSAGES.RETIREMENT_CASH_SURRENDER_VALUE,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 10],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_PDF,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_ANNUAL_TOTAL_PENSION_PDF,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', '', ''],
  ]
}

const buildLifeRetireAnnuallyHeaderTable = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.PREMIUM_PER_YEAR,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
      {
        text: _breakLine(MESSAGES.CUMULATIVE_PREMIUM),
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 20],
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_BEFORE_PENSION_WITH_NOTE,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_ALLOW_PENSION_NOTE_2,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
    ],
    [
      '',
      '',
      {
        text: MESSAGES.BASIC_PLAN,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 12],
      },
      {
        text: MESSAGES.RIDER_1_STAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 12],
      },
      {
        text: MESSAGES.TOTAL,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 12],
      },
      '',
      {
        text: MESSAGES.RETIREMENT_SURRENDER_VALUE_END_OF_YEAR_NOTE_PDF,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 10],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_PDF,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', '', ''],
  ]
}

const buildLifeRetireAnnuallyHeaderTableWithNoRiderAndTotalPremium = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.BASIC_PREMIUM_PER_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 20],
      },
      {
        text: _breakLine(MESSAGES.CUMULATIVE_PREMIUM),
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 20],
      },
      {
        text: MESSAGES.BENEFIT_BEFORE_GET_PENSION,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_ALLOW_PENSION_WITHOUT_NOTE,
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
    ],
    [
      '',
      '',
      '',
      '',
      {
        text: MESSAGES.RETIREMENT_SURRENDER_VALUE_END_OF_YEAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 10],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_PDF,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', ''],
  ]
}

export const buildPolicyValueTable = (
  policyValue,
  pensionType,
  basicPlan
  // $$FlowFixMe
) =>
  basicPlan.code === VALUES.LIFE_RETIRE_5
    ? buildLifeRetirePolicyValueTable(policyValue, pensionType)
    : buildIRetirePolicyValueTable(policyValue, pensionType)

export const policyValueTableSection = ({ policyValue, basicPlan, pensionType }) => [
  {
    text: Mustache.render(MESSAGES.RETIREMENT_POLICY_VALUE_TABLE, {
      pensionType: getPensionTypeString(pensionType),
    }),
    style: 'title',
    pageBreak: 'before',
    alignment: 'center',
  },
  ...buildPolicyValueTable(policyValue, pensionType, basicPlan),
  iRetireShowMessageUnderPdfTable({ policyValue, basicPlan }),
  disclaimer,
  basicPlan.code === VALUES.LIFE_RETIRE_5
    ? ''
    : {
        stack: [
          `${
            pensionType === 'monthly'
              ? MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_4_MONTHLY
              : MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_4_ANNUALLY
          }`,
          MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_5,
        ],
        style: 'disclaimer',
      },
]
